import { fromJS } from 'immutable'
import {
  CONSENT_LOG_GET_REQUEST,
  CONSENT_LOG_GET_SUCCESS,
  CONSENT_LOG_GET_FAILURE,
  CONSENT_LOG_GET_RESET
} from '../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case CONSENT_LOG_GET_REQUEST:
      return state
        .set('isFetching', true)
    case CONSENT_LOG_GET_SUCCESS:
      if (action.payload.ok) {
        return state
          .set('isFetching', false)
          .set('log', fromJS(action.payload.logs))
          .set('status', action.payload.ok)
      }
      return state
        .set('isFetching', false)
    case CONSENT_LOG_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case CONSENT_LOG_GET_RESET:
      return state
        .set('redirect', false)
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/consent-log/consent-log-get-reducer.js